export default {
      id: "icon-social-pinterest-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.svg#icon-social-pinterest",
      toString: function () {
        return this.url;
      }
    }